import {ApiReduxState} from 'src/api/reducers/types'
import {API_STATE_CHANGE_EVENT} from 'src/api/actions/actionsNames'

export function APIStateChange(state: Partial<ApiReduxState>): {
  type: string
  state: Partial<ApiReduxState>
} {
  return {type: API_STATE_CHANGE_EVENT, state}
}
